<template>
    <div>
        <div class="form_box">
          <el-table
          empty-text="暂无数据"
          :data="tableData"
          border>
            <el-table-column
                prop="name"
                label="姓名"
                min-width="50">
            </el-table-column>
            <el-table-column
                prop="mobileNo"
                label="手机号"
                min-width="50">
            </el-table-column>
            <el-table-column
                prop="nationalId"
                label="证件号码"
                min-width="50">
            </el-table-column>
            <el-table-column
                prop="email"
                label="邮箱"
                min-width="50">
            </el-table-column>
            <!-- <el-table-column
                prop="birthday"
                label="生日"
                min-width="50">
            </el-table-column> -->
            <el-table-column
                prop="op"
                label="操作"
                min-width="100">
                <template slot-scope="scope">
                    <el-button  type="text" size="small" @click="tores(scope.row.caseid)">删除</el-button>
                </template>
            </el-table-column>
          </el-table>
        </div>

    </div>
</template>


<script>
import constants from "@/util/constants.js";
export default {
  data() {
    return {
      tableData:[],
      token:JSON.parse(window.localStorage.getItem("data")).data
    };
  },
  methods: {
    getData() {
      this.tableData = [];
      let that = this;
      fetch(constants.domain + "rescue/case/list_sub_user", {
        method: "POST",
        body: `token=${this.token}&status=&start=1&count=10`,
        mode: "cors",
        headers: { "Content-Type": "application/x-www-form-urlencoded" }
      })
      .then(function(res) {
        return res.json();

      })
      .then(function(data) {
        that.tableData = data.obj;
      })
    }
  },
  mounted() {
    this.getData();
  }
};
</script>



// WEBPACK FOOTER //
// src/components/cmd_center/star/coordinatorlist.vue